import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  CardBody,
  Card,
  Dropdown,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Pagination,
  PaginationLink,
  PaginationItem,
  UncontrolledTooltip,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import classnames from "classnames";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

//Import Cards
import CardProject from "./card-project";

import { createSelector } from "reselect";
//import { API_URL } from "src/utils/apiConfig";
import DatePicker from  'react-datepicker';

import TableContainer from "src/components/Common/TableContainer";
import { size } from "lodash";
import { useGetProjectsQuery } from "src/services/khozi";


const Paginations = ({
  currentPage,
  totalPages,
  onPageChange,
  totalProjects,
}: any) => {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);


  return (
    <React.Fragment>
      <Row className="g-0">
        <Col sm={6}>
          <div>
            <p className="mb-sm-0">
              Mostrando {currentPage * 8 - 7} a {Math.min(currentPage * 8, 24)}{" "} de {totalProjects} entradas
            </p>
          </div>
        </Col>
        <Col sm={6}>
          <div className="float-sm-end">
            <ul className="pagination pagination-rounded mb-sm-0">
              <PaginationItem className="page-item" disabled={currentPage === 1}>
                <PaginationLink href="#" className="page-link" onClick={() => onPageChange(currentPage - 1)}>
                  <i className="mdi mdi-chevron-left"></i>
                </PaginationLink>
              </PaginationItem>
              {pages.map(page => (
                <PaginationItem key={page} className="page-item" active={page === currentPage}>
                  <PaginationLink href="#" className="page-link" onClick={() => onPageChange(page)}>
                    {page}
                  </PaginationLink>
                </PaginationItem>
              ))}
              <PaginationItem className="page-item" disabled={currentPage === totalPages}>
                <PaginationLink href="#" className="page-link" onClick={() => onPageChange(currentPage + 1)}>
                  <i className="mdi mdi-chevron-right"></i>
                </PaginationLink>
              </PaginationItem>
            </ul>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

const ProjectList = () => {
  document.title = "Actividades|Khozi";

  const [selectedProject, setSelectedProject] = useState<any>();
  const [modal, setModal] = useState(false);

  const dispatch = useDispatch();
  const selectLeadData = createSelector(
    (state: any) => state.projects.projects,
    leadsChart => leadsChart
  );
  // Inside your component
  //const projects = useSelector(selectLeadData);
  const {data : projects=[], isLoading, isSuccess, isError, error} = useGetProjectsQuery();
  const [activeTab, setactiveTab] = useState<string>("1");
  const [projectstatus, setprojectstatus] = useState<"ACTIVO" | "FINALIZADO" | "ALL">("ACTIVO");
  const toggleTab = (tab: any) => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };
  const [currentPage, setCurrentPage] = useState<number>(1);
  const projectsPerPage = 8;
  const totalPages = Math.ceil(projects.length / projectsPerPage);
  
  const filteredProjects = projects.filter((project: any) => {
    if (projectstatus === "ALL"){
      return true;
    }
    return project.status === projectstatus;
  });
  const totalProjects = filteredProjects.length;
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const sortedProjects = [...projects].sort(
    (a, b) => a.nome.localeCompare(b.nome)
  );
  const paginatedProjects = sortedProjects.slice(
    (currentPage - 1) * projectsPerPage,
    currentPage * projectsPerPage
  );
  const getDateMMyyyyFormatted = (date: Date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}${month}`;
  };
  const columns = useMemo(() => [
      {Header: "Departamento", accessor: "departamento", filterable: true, disableFilters: true, enableGrouping:true},
      {Header: "Actividade", accessor: "nome", filterable: true, disableFilters: true},
      {Header: "Equipa", accessor: "unidade_name", filterable: true, disableFilters: true},    
      {Header: "Responsável", accessor: "responsavel_name", filterable: true,disableFilters: true},
      {Header: "Último Ponto de Situação", accessor: "last_situation", filterable: true,disableFilters: true}
    ], []
  );
  const navigate = useNavigate(); 
  
  const handlaProjectClick = (row:any) => {
    navigate(`/projects/${row.id}`);
  }  

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  
  if (isLoading){
    return (
      <div style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    isLoading?(
      <div style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner color="primary" />
      </div>
    ):(
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>                  
              <TableContainer
                columns={columns}
                data={sortedProjects}
                isGlobalFilter={true}
                isAddUserList={true}
                customPageSize={100}
                className="custom-header-css"
                handleRowClick={handlaProjectClick}                        
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
)
};

export default ProjectList;
